import React from "react";
import "./PhilosophyNode.css";

const PhilosophyNode = ({
  title,
  description,
  animationDelay,
  index,
  style,
}) => {
  const combinedStyle = {
    ...style,
    animationDelay: `${animationDelay}s`,
  };

  return (
    <div className="philosophy-node-item" style={combinedStyle}>
      <div className="node-content-card">
        <div className="node-decorative-line"></div>
        <h3 className="node-title">
          <span className="node-number">{index + 1}.</span>
          {title}
        </h3>
        <p className="node-description">{description}</p>
      </div>
    </div>
  );
};

export default PhilosophyNode;
